import React, { createContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

export const MainContext = createContext(null);

export const MainProvider = ({
  children,
  jwtToken,
  currentGroupId: initialGroupId,
  currentUserId,
  supportedCurrencies,
  groups: initialGroups,
}) => {
  const [currentGroupId, setCurrentGroupId] = useState(initialGroupId);
  const [groups, setGroups] = useState(initialGroups);
  const [deviceToken, setDeviceToken] = useState(null);

  const value = useMemo(
    () => ({
      jwtToken,
      deviceToken,
      currentGroupId,
      currentUserId,
      groups,
      supportedCurrencies,
      setCurrentGroupId,
      setDeviceToken,
      setGroups,
    }),
    [
      jwtToken,
      deviceToken,
      currentGroupId,
      groups,
      currentGroupId,
      currentUserId,
    ]
  );
  return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
};

MainProvider.propTypes = {
  children: PropTypes.node.isRequired,
  jwtToken: PropTypes.string.isRequired,
  currentGroupId: PropTypes.any,
  currentUserId: PropTypes.number.isRequired,
};
